import React, { useEffect, useState } from "react";
import { QueryClient, useMutation, useQuery } from "react-query";
import { getAdminUsers, userActivation,userDeactivation } from "../../../api/apiServices";
import UserRoles from "../../../hooks/userRoles";
import useAuth from "../../../hooks/useAuth";
import jwt_decode from "jwt-decode";
import toast, { Toaster } from "react-hot-toast";
import PhoneInput from "react-phone-input-2";


const UserActivationManagement = () => {
	const { auth } = useAuth();
	const decoded = auth?.accessToken
		? jwt_decode(auth.accessToken)
		: undefined;

	const role = decoded?.UserInfo?.role || "";

	const [search, setSearch] = useState(false);
	const [users, setUsers] = useState({});
	const [user, setMember] = useState({});
	const [country, setCountry] = useState("gh");

	const [searchUser, setSearchUser] = useState({
		email: "",
		mobile_number: "",
		first_name: "",
		last_name: "",
	});

	useEffect(() => {
		getAdminUsers().then(res =>setUsers(res))
	}, [])
	
	
	const handleMobileNumber = (value, countryObj, e, formattedValue) => {
		const name = e.target.name;
		setSearchUser((prevData) => ({
			...prevData,
			[name]: value,
		}));
	};

	const handleOnChange = (e) => {
		const name = e.target.name;
		const value = e.target.value;
		setSearchUser((prevData) => ({
			...prevData,
			[name]: value,
		}));
	};

	
	const handleDeactivate = async (id, email, mobile_number) => {
		const deactivateData = {
			id: id,
			email: email,
			mobile_number: mobile_number,
		};
		await userDeactivation(deactivateData).then((res) => {
			if (res.success) {
                toast.success(res.message, {
                    duration: 5000,
                    className: "toast-message",
                });
				setSearch(false);
				setSearchUser({
					email: "",
					mobile_number: "233",
					first_name: "",
					last_name: "",
				});
                setMember(null);
            } else {
                toast.error(res.message, {
                    duration: 5000,
                    className: "toast-message",
                });
                setSearch(true);
                setMember(null);
            }
		});
	};
	const handleActivate = async (id, email, mobile_number) => {
		const activateData = {
			id: id,
			email: email,
			mobile_number: mobile_number,
		};
		await userActivation(activateData).then((res) => {
			if (res.success) {
                toast.success(res.message, {
                    duration: 5000,
                    className: "toast-message",
                });
				setSearch(false);
				setSearchUser({
					email: "",
					mobile_number: "233",
					first_name: "",
					last_name: "",
				});
                setMember(null);
            } else {
                toast.error(res.message, {
                    duration: 5000,
                    className: "toast-message",
                });
                setSearch(true);
                setMember(null);
            }
		});
	};

	
	

	const handleCancel = () => {
		setSearchUser({
			email: "",
			mobile_number: "233",
			first_name: "",
			last_name: "",
		});
		setCountry("gh");
		setSearch(false);
	};

	const handleSearch = async (e) => {
		e.preventDefault();
		if (users) {			
			if (role === UserRoles.SuperAdmin || role === UserRoles.SystemAdmin) {
				const userEmail = searchUser.email;
				const userMobileNumber = searchUser.mobile_number;
				const userFirstname = searchUser.first_name;
				const userLastname = searchUser.last_name;
	
				const findUser = users?.find(
					(user) =>
						user.email === userEmail ||
						user.mobile_number === userMobileNumber ||
						user.first_name === userFirstname ||
						user.last_name === userLastname
				);
	
				if (findUser) {
					setSearch(true);
					setMember(findUser);
				} else {
					setSearch(false);
				}
			} else {
				toast.error(
					"You are not authorized to perform this function. Contact the System Administrator",
					{
						duration: 3000,
						className: "toast-message",
					}
				);
				return false;
			}
		}
	};

	const searchContent = (
		<form>
			<div className="form-group row">
				<div className="col-sm-3">
					<input
						type="text"
						style={{
							width: "100%",
							height: 40,
							fontSize: 16,
							textTransform: "uppercase",
							borderRadius: 5,
						}}
						placeholder="Email Address"
						name="email"
						onChange={handleOnChange}
						className="form-control"
					/>
				</div>
				<div className="col-sm-3">
					<PhoneInput
						inputStyle={{
							fontSize: 16,
							color: "gray",
							width: "100%",
							height: 40,
						}}
						country={country}
						countryCodeEditable={false}
						enableSearch={true}
						enableClickOutside={false}
						value={searchUser.mobile_number}
						inputProps={{
							name: "mobile_number",
							autoFocus: true,
						}}
						onChange={(value, countryObj, e, formattedValue) =>
							handleMobileNumber(
								value,
								countryObj,
								e,
								formattedValue
							)
						}
					/>
				</div>
				<div className="col-sm-2">
					<input
						className="form-control"
						type="text"
						placeholder="FirstName"
						style={{
							width: "100%",
							height: 40,
							fontSize: 16,
							textTransform: "uppercase",
							borderRadius: 5,
						}}
						name="first_name"
						onChange={handleOnChange}
					/>
				</div>
				<div className="col-sm-2">
					<input
						className="form-control"
						type="text"
						placeholder="LastName"
						style={{
							width: "100%",
							height: 40,
							fontSize: 16,
							textTransform: "uppercase",
							borderRadius: 5,
						}}
						name="last_name"
						onChange={handleOnChange}
					/>
				</div>
				<div className="col-sm-2">
					<button
						type="button"
						onClick={handleSearch}
						className="btn btn-success btn-block"
					>
						Search Member
					</button>
				</div>
			</div>
		</form>
	);

	const content = (
		<div className="table-responsive lg">
			<table className="table table-borderless table-hover table-striped">
				<thead className="align">
					<tr>
						<th scope="col">User ID</th>
						<th scope="col">Full Name</th>
						<th scope="col">User Role</th>
						<th scope="col">Email Address</th>
						<th scope="col">Mobile Number</th>
						<th scope="col" style={{ textAlign: "center" }}>Action</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>{user?.id}</td>
						<td style={{ whiteSpace: "nowrap" }}>
							{user?.first_name +
								" " +
								user?.middle_name +
								" " +
								user?.last_name}
						</td>
						<td>{user?.role?.role_name}</td>
						<td>{user?.email}</td>
						<td style={{ whiteSpace: "nowrap" }}>
							{user?.mobile_number}
						</td>
						<td style={{ whiteSpace: "nowrap", textAlign: "center" }}>
							<div
								style={{
									display: "inline-block",
									whiteSpace: "nowrap",
								}}
							>
								<button
									className="btn"
									onClick={() => handleActivate(
										user?.id,
										user?.email,
										user?.mobile_number
									)}

								>
									<i className="fa fa-edit"></i> Activate
								</button>
							
								<button
									className="btn"
									onClick={() => handleDeactivate(
										user?.id,
										user?.email,
										user?.mobile_number
									)}

								>
									<i className="fa fa-edit"></i> Deactivate
								</button>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	);

	return (
		<>
			<section className="content-header">
				<Toaster toastOptions={{ position: "top-center" }} />
				<h1>User Activation Management </h1>
			</section>
			<section className="content">
				<div className="box">
					<div className="box-body">
						<div className="panel panel-default panel-br-4">
							<div className="panel-heading">
								<div className="row">
									<div className="col-sm-12">
										<h4 className="panel-title">
											{searchContent}
										</h4>
									</div>
								</div>
							</div>
							{search && (
								<>
									<div className="panel-body">{content}</div>
									<div className="panel-footer">
										<div className="search-group">
											<button
												type="submit"
												className="btn btn-danger "
												onClick={handleCancel}
											>
												{" "}
												<i className="fa fa-search"></i>{" "}
												Cancel
											</button>
										</div>
									</div>
								</>
							)}
						</div>
					</div>
				</div>
			</section>
		</>
	);
};

export default UserActivationManagement;
